export const API_URL = 'https://api.nairanbenri.com:3001/api/v1';
export const SOCKET_URL = 'https://api.nairanbenri.com:3001';
export const SOCKET_PATH = '/api/v1/socket';
export const WEB_NAME = 'GuardLock';
